import { useMemo } from 'react';

const useYearsOptions = ({ startYear: startYearProps, endYearProps }) => {
  const endYear = endYearProps || new Date().getFullYear();
  const startYear = startYearProps || +endYear - 20;

  const yearsArray = useMemo(
    () => Array.from({ length: endYear - startYear + 1 }, (_, index) => endYear - index),
    [startYear, endYear],
  );

  return useMemo(() => yearsArray.map((year) => ({ label: String(year), value: year + '' })), [yearsArray]);
};

export default useYearsOptions;
